import { getAppStatusFilteredOptions, mapStatusResponse } from "helpers";
import { staticDropdownValuesService } from "services";

const loadOptions = async search => {
	try {
		let options = await staticDropdownValuesService
			.getApplicationStatuses()
			.then(mapStatusResponse);

		let filteredOptions = getAppStatusFilteredOptions(options, search);

		return {
			options: filteredOptions,
			hasMore: false,
		};
	} catch {
		return { options: [] };
	}
};

const applicationStatusColumn = () => ({
	name: "applicationStatus",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.name,
	getOptionValue: option => option,
	placeholder: "App Status",
	isSubOption: data => data.parentStatusId,
});

export default applicationStatusColumn;
